webpackJsonp([212839066777427],{

/***/ 552:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 690:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.pageQuery = undefined;
	
	var _react = __webpack_require__(9);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(108);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _msiteModule = __webpack_require__(72);
	
	var _msiteModule2 = _interopRequireDefault(_msiteModule);
	
	__webpack_require__(552);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	//require(`katex/dist/katex.min.css`)
	
	var BlogPage = function BlogPage(_ref) {
	  var data = _ref.data;
	  return _react2.default.createElement(
	    'div',
	    { className: _msiteModule2.default.nobordcontent },
	    _react2.default.createElement(
	      'h2',
	      null,
	      ' Latest Posts '
	    ),
	    data.allMarkdownRemark.edges.map(function (post) {
	      return _react2.default.createElement(
	        'div',
	        { key: post.node.id, className: _msiteModule2.default.bsummary },
	        _react2.default.createElement(
	          'h2',
	          null,
	          post.node.frontmatter.title
	        ),
	        _react2.default.createElement(
	          'small',
	          null,
	          'Posted by ',
	          post.node.frontmatter.author,
	          ' on',
	          ' ',
	          post.node.frontmatter.date
	        ),
	        _react2.default.createElement(
	          _gatsbyLink2.default,
	          { to: post.node.frontmatter.path },
	          _react2.default.createElement(
	            'span',
	            { className: _msiteModule2.default.bspan },
	            ' Read More '
	          )
	        )
	      );
	    })
	  );
	};
	
	var pageQuery = exports.pageQuery = '** extracted graphql fragment **';
	
	exports.default = BlogPage;

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-blog-js-d59a6bdb850829de694a.js